import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, catchError, map, of } from 'rxjs';
import { CurrentContextService } from '../context/current-context.service';
import { hasAccess } from './permission-access';

function evaluate(
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  context: ReturnType<CurrentContextService['context']>,
  router: Router
): true | ReturnType<Router['parseUrl']> {
  const requiredPermission = (route.data['requiredPermission'] as string | undefined) ?? null;
  const requiredEntitlement = (route.data['requiredEntitlement'] as string | undefined) ?? null;
  const requiredAction = (route.data['requiredAction'] as string | undefined) ?? null;

  if (hasAccess(context, requiredPermission, requiredEntitlement, requiredAction)) {
    return true;
  }

  if (state.url.startsWith('/login')) {
    return true;
  }

  return router.parseUrl('/dashboard');
}

export const permissionGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Observable<true | ReturnType<Router['parseUrl']>> | true | ReturnType<Router['parseUrl']> => {
  const contextService = inject(CurrentContextService);
  const router = inject(Router);

  const context = contextService.context();
  if (context) {
    return evaluate(route, state, context, router);
  }

  return contextService.loadContext().pipe(
    map(loadedContext => evaluate(route, state, loadedContext, router)),
    catchError(() => of(router.parseUrl('/dashboard')))
  );
};
